<div *ngIf="annotations.length > 0" class="annotations-panel">
  <div #annotationsList class="annotations-list" [class.annotations-list--single]="annotations.length === 1">
    <po-widget
      *ngFor="let ann of annotations; trackBy: trackByAnnotation"
      [attr.id]="ann.findingId ? 'finding-' + ann.findingId : null"
      class="annotation-widget"
      [attr.data-severity]="ann.severityColor"
      [attr.data-type]="ann.type"
      [attr.data-line]="ann.line"
      [class.annotation-widget-active]="isActive(ann)"
      p-no-shadow="true"
      (p-click)="navigateTo(ann)">

      <div class="annotation-header">
        <span class="annotation-header-icon">{{ annotationIcon(ann) }}</span>
        <!-- Severidade (ação) ou categoria (sugestão) como subtítulo do cabeçalho: a cor dele
             já diz a gravidade, e um selo numa linha própria custava uma linha por card. -->
        <span class="annotation-header-text">
          <span class="annotation-header-title" [attr.title]="annotationTypeLabel(ann)">{{ annotationTypeLabel(ann) }}</span>
          <span class="annotation-header-qualifier" *ngIf="annotationQualifier(ann) as qualifier" [attr.title]="qualifier">{{ qualifier }}</span>
        </span>
        <po-button
          class="annotation-copy-btn"
          p-kind="tertiary"
          [p-icon]="isCopied(ann) ? 'po-icon-ok' : 'po-icon-copy'"
          [p-tooltip]="isCopied(ann) ? 'Copiado!' : 'Copiar card'"
          p-tooltip-position="top"
          p-append-in-body="true"
          (p-click)="copyAnnotation(ann)"
          (click)="$event.stopPropagation()">
        </po-button>
        <po-tag
          [p-value]="'L' + ann.line"
          [p-tooltip]="'Clique para navegar para a linha ' + ann.line"
          p-tooltip-position="top"
          p-append-in-body="true"
          p-type="neutral"
          p-orientation="horizontal">
        </po-tag>
      </div>

      <div class="annotation-header-meta" *ngIf="ann.sonarRule || ann.sonarSeverity || ann.sonarIssueType">
        <po-tag
          *ngIf="ann.sonarRule"
          [p-value]="'Regra Sonar: ' + ann.sonarRule"
          p-type="neutral"
          p-orientation="horizontal">
        </po-tag>
        <po-tag
          *ngIf="ann.sonarSeverity"
          [p-value]="'Severidade Sonar: ' + ann.sonarSeverity"
          p-type="info"
          p-orientation="horizontal">
        </po-tag>
        <po-tag
          *ngIf="ann.sonarIssueType"
          [p-value]="'Tipo Sonar: ' + ann.sonarIssueType"
          p-type="success"
          p-orientation="horizontal">
        </po-tag>
      </div>

      <div class="annotation-body">
        <div *ngIf="ann.description">
          <span class="annotation-section-label">Problema</span>
          <div class="annotation-description sr-md-content" [innerHTML]="ann.description | markdown"></div>
        </div>
        <div class="annotation-detail-wrap" *ngIf="ann.detail">
          <span class="annotation-section-label">{{ ann.type === 'suggestion' ? 'Benefício' : 'Ação' }}</span>
          <div class="annotation-detail sr-md-content" [innerHTML]="ann.detail | markdown"></div>
        </div>
      </div>

      <div
        class="annotation-feedback"
        *ngIf="canShowFeedback(ann)"
        (click)="$event.stopPropagation()">
        <app-review-feedback
          [resourceType]="resourceType"
          [resourceId]="resourceId"
          [findingKind]="ann.findingKind"
          [findingId]="ann.findingId"
          [answerArtifactId]="answerArtifactId"
          [initialResolution]="feedbackFor(ann)?.resolution ?? null"
          [initialComment]="feedbackFor(ann)?.comment"
          [feedbackId]="feedbackFor(ann)?.id"
          [compact]="true"
          (feedbackChanged)="feedbackChanged.emit($event)">
        </app-review-feedback>
        <app-review-other-feedback
          [feedbacks]="otherFeedbackFor(ann)"
          (removed)="otherFeedbackRemoved.emit($event)">
        </app-review-other-feedback>
      </div>
    </po-widget>
  </div>
</div>

<div *ngIf="annotations.length === 0" class="annotations-empty-state po-mt-2">
  <po-info [p-label]="emptyStateLabel" [p-value]="emptyStateValue"></po-info>
  <po-button
    *ngIf="hasHiddenFindingsWithLine"
    class="annotations-empty-state-action"
    p-kind="secondary"
    p-icon="po-icon-eye"
    p-label="Mostrar todos os cards"
    p-tooltip="Exibe ações e sugestões ocultas"
    p-tooltip-position="top"
    p-append-in-body="true"
    (p-click)="requestShowAll()">
  </po-button>
</div>
